export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // Check for updates every time the page loads
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // New content available — show a refresh prompt
              showUpdateBanner();
            }
          };
        };
      })
      .catch((err) => console.error('[SW] Registration failed:', err));
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((r) => r.unregister())
      .catch((err) => console.error(err));
  }
}

function showUpdateBanner() {
  const banner = document.createElement('div');
  banner.dir = 'rtl';
  Object.assign(banner.style, {
    position: 'fixed', top: '0', left: '0', right: '0', zIndex: '9999',
    background: '#1e40af', color: '#fff',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '12px 20px', fontFamily: 'Cairo, Arial, sans-serif', fontSize: '14px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.3)',
  });

  const label = document.createElement('span');
  label.textContent = '🔄 يتوفر تحديث جديد للتطبيق';

  const btn = document.createElement('button');
  btn.textContent = 'تحديث الآن';
  Object.assign(btn.style, {
    background: '#fff', color: '#1e40af', border: 'none', borderRadius: '8px',
    padding: '6px 16px', fontFamily: 'inherit', fontWeight: '700',
    cursor: 'pointer', fontSize: '13px',
  });
  btn.addEventListener('click', () => window.location.reload());

  banner.appendChild(label);
  banner.appendChild(btn);
  document.body.prepend(banner);
}
